import { Component } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { FuseConfigService } from '../../core/services/config.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthDataManager } from '../../data/auth.datamanager';
import { UsersDataManager } from '../../data/users.datamanager';
import { MatDialog, MatSnackBar } from '@angular/material';
import { ErrorResponse } from '../../data/model/errorResponse';
import { ProfileDialogComponent } from './profile/profile.dialog.component';

@Component({
    selector   : 'fuse-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls  : ['./toolbar.component.scss']
})

export class FuseToolbarComponent
{
    userStatusOptions: any[];
    languages: any;
    selectedLanguage: any;
    showLoadingBar: boolean;
    horizontalNav: boolean;
    username: String;

    constructor(
        private authDataManager: AuthDataManager,
        private usersDataManager: UsersDataManager,
        public snackBar: MatSnackBar,
        private router: Router,
        private dialog: MatDialog,
        private fuseConfig: FuseConfigService,
        private translate: TranslateService
    )
    {
        this.username =  localStorage.getItem('name');
        this.userStatusOptions = [
            {
                'title': 'Online',
                'icon' : 'icon-checkbox-marked-circle',
                'color': '#4CAF50'
            },
            {
                'title': 'Away',
                'icon' : 'icon-clock',
                'color': '#FFC107'
            },
            {
                'title': 'Do not Disturb',
                'icon' : 'icon-minus-circle',
                'color': '#F44336'
            },
            {
                'title': 'Invisible',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#BDBDBD'
            },
            {
                'title': 'Offline',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#616161'
            }
        ];

        this.languages = [
            {
                'id'   : 'en',
                'title': 'English',
                'flag' : 'us'
            },
            {
                'id'   : 'tr',
                'title': 'Turkish',
                'flag' : 'tr'
            }
        ];

        this.selectedLanguage = this.languages[0];

        router.events.subscribe(
            (event) => {
                if ( event instanceof NavigationStart )
                {
                    this.showLoadingBar = true;
                }
                if ( event instanceof NavigationEnd )
                {
                    this.showLoadingBar = false;
                }
            });

        this.fuseConfig.onSettingsChanged.subscribe((settings) => {
            this.horizontalNav = settings.layout.navigation === 'top';
        });

    }

    editUser()
    {
        this.usersDataManager.getLoggedInUser().subscribe(
            (res) => {
                      const dialogRef = this.dialog.open(ProfileDialogComponent, {
                        height: '530px',
                        width: '400px',
                        data : {
                          response: res,
                          userRole: localStorage.getItem('role')
                        }
                    });
            
                    dialogRef.afterClosed().subscribe(result => {
                        if (result !== null && result !== undefined){
                            if (typeof result === 'string'){
                                this.showMessage(result);
                            }
                            else{
                                this.showError(result);
                            }
                        }
                    });
            },
            (err) => {
                this.showError(err.json());
            }
        );
    }

    openTwoFactorSettings() {
        this.router.navigate(['/two-factor']);
    }

    logout(){
        this.authDataManager.logout();
        this.router.navigate(['/login']);
    }

    search(value)
    {
        // Do your search here...
        console.log(value);
    }

    setLanguage(lang)
    {
        // Set the selected language for toolbar
        this.selectedLanguage = lang;

        // Use the selected language for translations
        this.translate.use(lang.id);
    }

    showMessage(message: string){
        this.snackBar.open(message, null, {duration: 5000});
      }
  
      showError(message: ErrorResponse) {
        if (message.errors !== null && message.errors !== undefined &&
            message.errors.length > 0) {
          this.snackBar.open(message.errors[0].message, null, {duration: 10000});
        } else {
          this.snackBar.open('Unknown error occured', null, {duration: 10000});
        }
      }
}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/toolbar/toolbar.component.ts